// @flow

import type { EmployeesState } from "@modules/employee/reducer";
import defaultState from "./state";

export const onResetActiveClients = (state: EmployeesState) => () => {
  return {
    ...state,
    error: null,
    clients: defaultState,
  };
};
export const onGetActiveClients = (state: EmployeesState) => () => {
  return {
    ...state,
    error: null,
    clients: {
      ...state.clients,
      requestsInProgress: ++state.clients.requestsInProgress,
    },
  };
};

export const onGetActiveClientsSuccess = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    clients: {
      ...state.clients,
      requestsInProgress: --state.clients.requestsInProgress,
      list: payload,
    },
  };
};

export const onGetActiveClientsError = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    clients: {
      ...state.clients,
      requestsInProgress: --state.clients.requestsInProgress,
      list: {
        ...state.clients.list,
        content: [],
      },
    },
  };
};
